import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import routesTS from '@/servicesTS/routesTSBeta'
import routeService from '@/servicesTS/routes.service'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = routesTS.getRoutes()

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to: any, from: any, next: any) => {
    routeService.routeAccess(to, from, next)
})

export default router
